import { Button } from "./button";

export default function EmptyState({
  heading,
  action,
  actionText,
  content,
  icon,
  img = "https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png",
}) {
  return (
    <div className="text-center flex flex-col justify-center">
      <img
        src={img}
        alt="logo fichier vide"
        className="mx-auto w-full max-w-[10%] h-auto object-contain"
      />

      <h3 className="mt-2 text-sm font-semibold text-gray-900">{heading}</h3>
      <p className="mt-1 text-sm text-gray-500">{content}</p>
      {!!actionText && (
        <div className="mt-6">
          <Button color="primaryButton" onClick={action}>
            {icon}
            {actionText}
          </Button>
        </div>
      )}
    </div>
  );
}
